import React, { useEffect } from "react";
import Header from "../components/Header";
import "../styles/global.css";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Privacy Policy | Relationship Wellness";
  }, []);

  return (
    <div className="privacy-container">
      <Header />
      <div
        className="container"
        style={{ maxWidth: 800, margin: "0 auto", padding: "3rem 0" }}>
        <h1 style={{ marginBottom: 20 }}>Privacy Policy</h1>
        <p>
          <strong>Last updated:</strong> {new Date().getFullYear()}-01-01
        </p>
        <p>
          At Relationship Wellness, we take your privacy seriously. This Privacy
          Policy describes how your personal information is collected, used, and
          shared when you visit or interact with our website.
        </p>
        <h2>Information We Collect</h2>
        <ul>
          <li>
            <b>Personal Data:</b> We collect information that you submit
            voluntarily, such as your email address when you sign up for our
            newsletter or contact us.
          </li>
          <li>
            <b>Assessment Responses:</b> If you use our relationship assessment,
            your answers are stored anonymously and not linked to your identity.
          </li>
          <li>
            <b>Usage Data:</b> We collect non-personal usage data (e.g., pages
            viewed, time spent) via cookies, analytics, and similar
            technologies.
          </li>
        </ul>
        <h2>How We Use Your Information</h2>
        <ul>
          <li>To provide, maintain, and improve our services</li>
          <li>
            To send you newsletters, updates, or information you’ve requested
          </li>
          <li>To analyze website usage so we can improve user experience</li>
          <li>To comply with legal obligations</li>
        </ul>
        <h2>Cookies and Analytics</h2>
        <p>
          We use cookies and analytics tools (such as Google Analytics) to
          understand how you use our site and to improve performance. You can
          disable cookies via your browser settings but some features may not
          work as intended.
        </p>
        <h2>Advertising & Third Parties</h2>
        <p>
          We may show advertisements provided by third-party ad networks (e.g.,
          Google AdSense). These networks may use cookies and collect data to
          display relevant ads. Please review the privacy policies of these
          third parties for more information.
        </p>
        <h2>Data Security</h2>
        <p>
          We strive to keep your data secure with current industry-standard
          safeguards. However, no method of transmission over the Internet or
          electronic storage is 100% secure.
        </p>
        <h2>Your Rights</h2>
        <ul>
          <li>
            You may request to access, update, or delete your personal
            information by contacting us.
          </li>
          <li>
            European users (GDPR) and California residents (CCPA) have specific
            rights regarding their data. Please email us for requests.
          </li>
        </ul>
        <h2>Children's Privacy</h2>
        <p>
          Our services are not intended for anyone under the age of 16. We do
          not knowingly collect information from children. If you believe your
          child has provided us with personal data, contact us to have it
          removed.
        </p>
        <h2>Changes To This Policy</h2>
        <p>
          We may update this Privacy Policy occasionally. Changes will be posted
          on this page with the updated effective date.
        </p>
        <h2>Contact Us</h2>
        <p>
          For any privacy-related questions or requests, please contact us at{" "}
          <a href="mailto:support@nivexa.net">support@nivexa.net</a>.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
